$(document).ready(function () {
  const images = $('.custom-ellie-pick .wrapper img');
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  const total = images.length;
  const fadeDuration = 1500;
  const delay = 2000;

  if (isMobile) {
    let currentIndex = 0;

    function changeMobileImage() {
      const nextIndex = (currentIndex + 1) % total;
      images.eq(nextIndex).addClass('fade-in').css('z-index', 2);
      images.eq(currentIndex).css('z-index', 1);

      setTimeout(() => {
        images.eq(currentIndex).removeClass('fade-in');
        currentIndex = nextIndex;
      }, fadeDuration);

      setTimeout(changeMobileImage, delay * 2);
    }

    images.eq(currentIndex).addClass('fade-in').css('z-index', 2);
    setTimeout(changeMobileImage, delay * 2);

  } else {
    const half = total / 2;
    const leftImages = images.slice(0, half);
    const rightImages = images.slice(half);
    let currentPairIndex = 0;
    let previousLeft = leftImages[0];
    let previousRight = rightImages[0];

    function changeLeft() {
      const nextLeft = $(leftImages[currentPairIndex]);

      if (previousLeft !== nextLeft[0]) {
        nextLeft.addClass('fade-in active-left').css('z-index', 2);
        $(previousLeft).css('z-index', 1);

        setTimeout(() => {
          $(previousLeft).removeClass('fade-in active-left');
          previousLeft = nextLeft[0];
        }, fadeDuration);
      }

      setTimeout(changeRight, delay);
    }

    function changeRight() {
      const nextRight = $(rightImages[currentPairIndex]);

      if (previousRight !== nextRight[0]) {
        nextRight.addClass('fade-in active-right').css('z-index', 2);
        $(previousRight).css('z-index', 1);

        setTimeout(() => {
          $(previousRight).removeClass('fade-in active-right');
          previousRight = nextRight[0];
        }, fadeDuration);
      }

      currentPairIndex = (currentPairIndex + 1) % leftImages.length;

      setTimeout(changeLeft, delay);
    }

    // Mostrar primer par inmediatamente
    $(previousLeft).addClass('fade-in active-left').css('z-index', 2);
    $(previousRight).addClass('fade-in active-right').css('z-index', 2);

    setTimeout(changeLeft, delay * 2);
  }
});




//Close Menu on Click over Close Button
$(document).ready(function () {
  $(document).on("click", ".close-menu", function(){
      var opcl = $("#Details-HeaderMenu-1").attr('open');
      if (typeof opcl !== 'undefined' && opcl !== false) {
          $(".list-menu--inline li.custom-first_child-1").find('details').eq(0).removeAttr('open','');
  		$(".list-menu--inline li.custom-first_child-1").find('summary').eq(0).attr('aria-expanded','false');
      }

    var opcl2 = $("#Details-HeaderMenu-2").attr('open');
      if (typeof opcl2 !== 'undefined' && opcl2 !== false) {
          $(".list-menu--inline li.custom-first_child-2").find('details').eq(0).removeAttr('open','');
  		$(".list-menu--inline li.custom-first_child-2").find('summary').eq(0).attr('aria-expanded','false');
      }
  });
});


$(document).ready(function () {
  const $listItems = $('body.template-product .product__media-list li');
  const $dotsContainer = $('body.template-product .dots');

  // Create dots based on number of li elements
  $listItems.each(function (index) {
    $dotsContainer.append('<div class="dot" data-index="' + index + '"></div>');
  });

  // Set first dot as active
  $('.dot').first().addClass('active');

  // Calculate and apply margin-top dynamically
  function updateDotsMargin() {
    let dotsHeight = $dotsContainer.outerHeight();
    $('body.template-product .product media-gallery').css('margin-top', `-${dotsHeight}px`); // Center vertically if needed
  }

  updateDotsMargin(); // Apply initially

  // Recalculate on window resize
  $(window).on('resize', updateDotsMargin);

  // Handle click event on dots
  $('.dot').on('click', function () {
    const index = $(this).data('index');
    const $target = $listItems.eq(index);

    // Smooth scroll to target li
    $('html, body').animate({
      scrollTop: $target.offset().top
    }, 500);

    // Update active class on dots
    $('.dot').removeClass('active');
    $(this).addClass('active');
  });

  // Highlight active dot based on scroll position
  $(window).on('scroll', function () {
    let scrollPosition = $(window).scrollTop();

    $listItems.each(function (index) {
      if ($(this).offset().top <= scrollPosition + 10) {
        $('.dot').removeClass('active');
        $('.dot').eq(index).addClass('active');
      }
    });
  });
});

/* Script for Adding Class when Search is Open */
$(document).ready(function() {
  $('body').on("click", ".icon.icon-search", function(){
    if($(".search-open-header").length > 0 ){ } else{
      $(".section-header.custom-search-header").addClass('search-open-header');
      $('html').addClass("search-open-body");
    }
  });
});

$(document).mouseup(function(e){
    var searchOut = $(".icon.icon-search");
    if (!searchOut.is(e.target) && searchOut.has(e.target).length === 0){
        $(".section-header.custom-search-header").removeClass('search-open-header');
        $('html').removeClass("search-open-body");
    }
});

jQuery(document).on('keyup',function(evt) {
    if (evt.keyCode == 27 || evt.keyCode == "Escape" ) {
       $(".section-header.custom-search-header").removeClass('search-open-header');
       $('html').removeClass("search-open-body");
    }
});

$(document).ready(function(){
    $('body').on("click", ".search-modal .search-modal__close-button", function(){
    if($(".search-open-header").length > 0){
      $(".section-header.custom-search-header").removeClass('search-open-header');
      $('html').removeClass("search-open-body");
    }
  });
});

/*Menu Close JS*/
$(document).ready(function(){
  $('body').on("click", ".close_menu-custom", function(){
    if (window.matchMedia('(max-width: 992px)').matches) {
      $(".menu-drawer-container").removeClass("menu-opening");
      $(".menu-drawer-container").removeAttr("open");
      $(".menu-drawer-container .header__icon.header__icon--menu.header__icon--summary").attr('aria-expanded', false);
    }
  });
});

/* JS for Collection & Home Card Product Variant Image Change*/
$(document).ready(function(){
  $('input').on("click", function(){
    var id = $(this).attr("id");
    var selected_img = $(this).attr("vari-img");
    var var_id = $(this).attr("variant-id");
    var curr_url = $(this).parents(".card__content").find(".card__information .card__heading a").attr("variant-url");
    $(this).parents(".card__content").siblings(".card__inner").find(".card__media .media img").attr("srcset", selected_img);
    //console.log(curr_url);
    if(curr_url.indexOf('?') > -1 ){
      $(this).parents(".card__content").find(".card__information .card__heading a").attr("href", curr_url+"&variant="+var_id);
      $(this).parents(".card__content").find(".card-information .custom-plus-info a").attr("href", curr_url+"&variant="+var_id);
    } else {
      $(this).parents(".card__content").find(".card__information .card__heading a").attr("href", curr_url+"?variant="+var_id); 
      $(this).parents(".card__content").find(".card-information .custom-plus-info a").attr("href", curr_url+"?variant="+var_id);
    }
    //console.log("id is "+id+ " image is "+selected_img);
  });
});

$(document).ready(function(){
  if (window.matchMedia('(max-width: 992px)').matches) {
      $("html body header nav .menu-drawer__menu details").attr("open" , true);
  }
});

$(document).ready(function(){
  jQuery(".header__icon--menu").on("click", function () {
    jQuery("html").toggleClass("menu-open");
  });
  jQuery(".close_menu-custom").on("click", function () {
    jQuery("html").removeClass("menu-open");
  });
});

$(document).ready(function(){
  $(".product__media-zoom-lightbox").on("click", function(){
    $('html').addClass("zoom-open"); 
  });
  $(".product-media-modal.media-modal").on("click", function(){
    $('html').removeClass("zoom-open"); 
  });
});